import { useEffect } from "react";
import { useSiteContent } from "@/lib/siteContent";

/**
 * Injects a JSON-LD <script> tag describing this site as a LocalBusiness so
 * Google can show rich results (logo, hours, location, etc.) in search.
 */
export default function StructuredData() {
  const { content } = useSiteContent();
  const site = content?.site || {};

  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://cozycovetn.com/#localbusiness",
      "name": site.siteName || "The Cozy Cove",
      "description": "Luxury indoor teepee sleepover experiences for children's birthdays, celebrations, and special nights — delivered, set up, styled, and removed.",
      "url": "https://cozycovetn.com",
      "telephone": site.contactPhone || undefined,
      "email": site.contactEmail || undefined,
      "image": site.ogImageUrl || site.heroImageUrl || undefined,
      "logo": site.ogImageUrl || undefined,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Lynchburg",
        "addressRegion": "TN",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.282,
        "longitude": -86.373
      },
      "areaServed": site.serviceArea || "Greater Metro Area & 30-mile radius",
      "sameAs": [
        site.instagramHandle ? `https://instagram.com/${(site.instagramHandle || "").replace("@","")}` : null,
        site.facebookHandle ? `https://facebook.com/${site.facebookHandle}` : null,
      ].filter(Boolean),
      "priceRange": "$$",
    };

    let tag = document.getElementById("ld-localbusiness");
    if (!tag) {
      tag = document.createElement("script");
      tag.id = "ld-localbusiness";
      tag.type = "application/ld+json";
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(data);
  }, [site]);

  return null;
}
